import React from 'react';
import { toShortFormatedDate } from "../../utils/dateUtils";

const VacationEnd = ({ date }) => {
    return (
        <>
            &nbsp;-&nbsp;
            {toShortFormatedDate(date)}
        </>
    );
};

const VacationStart = ({ date }) => {
    return toShortFormatedDate(date);
};

export { VacationStart, VacationEnd };
